
import VuePicker from 'vue-pickers'
import { Component, Vue } from 'vue-property-decorator'
// 引入现有的依赖和方法
import { UserModule } from '@/store/modules/user'
import { SYSAPI } from '@/api/sys'
import { USERAPI } from '@/api/users'
import {
  setuserCurrentApp,
  setRole,
  setuserCurrentAppName,
  getuserCurrentApp,
  getIsSingleEntry,
  getuserCurrentAppName,
  getDisplayName,
  getToken
} from '@/utils/cookies'
import { AppModule, DeviceType } from '@/store/modules/app'
import { dashboardTicketKeywords } from '@/utils/commonFunc'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'

import { ADMINISISSUESAPI, baseURL } from '@/api/administration'
import { FWBZISISSUESAPI } from '@/api/fwbz'
import { CGGLISISSUESAPI } from '@/api/cggl'
import { SCGLISISSUESAPI } from '@/api/scgl'
import { SPYYISISSUESAPI } from '@/api/spyy'
import { GYGLISISSUESAPI } from '@/api/gygl'
import { ISSUESAPI } from '@/api/issues'
import app from "@/App.vue";
// 接口定义在组件文件中
interface LocationItem {
  value: number;
  label: string;
  children?: LocationItem[];
}
@Component({
  components: {
    VuePicker
  }
})
export default class CreateIndex extends Vue {
  private pageLoading: any = null; // 页面加载中, 相当于蒙层功能，限制用户多次点击无效
  private sysAppDataList: Array<any> = []; // 系统app数据
  private selectedApp: any = null; // 选中的应用
  private isMobile = false; // 是否为手机端
  private locationOptions = [] as LocationItem[];// 所在地区options
  private isDisableSubmit = false; // 避免重复触发提交按钮
  private pickerLocationVisible = false; // 点击所在地区文本框，显示picker联动
  private defaultIssueIndex = [] as number[]; // 默认联动定位，从0开始，0代表第一行
  private liveIssueCn = ''; // 移动端：所在地区内容
  private issueTypeOptions = []; // 问题类型options
  private inputWaringDesc=''

  formData = {
    tutorName: this.username,
    issueDate: new Date(),
    location: [] as any,
    position: '',
    describe: '',
    remark: '',
    is_living: 0,
    fileList: [] as Array<{ image_url: string; name: string }>
  };

  formRules: object = {
    tutorName: [{ required: true }],
    issueDate: [{ required: true }],
    is_living: [{ required: true, message: '请选择是否正在直播', trigger: 'change' }],
    location: [
      { required: true, message: '请选择所在地区', trigger: 'change' }
    ],
    position: [{ required: true, message: '请准确描述您的位置', trigger: 'blur' }],
    describe: [
      {
        required: true,
        message: '表扬/咨询/报修/建议，请详细描述您的问题',
        trigger: 'blur',
        min: 1
      }
    ]
  };

  private getInputDesc() {
    switch (this.selectedApp) {
      case '1':
      case '2':
      case '3':
        return '请简要描述下您遇到的问题'
      case '5':
        return '表扬/咨询/报修/建议，请详细描述您的问题'
    }
  }

  private skipToJumper() {
    this.$router.push({ path: '/jumper' })
  }

  // 监听 selectedApp 的变化
  handleAppChange(newApp: string) {
    this.liveIssueCn = ''
    this.defaultIssueIndex = [0, 0, 0]
    this.formData.location = [0, 0, 0]
    // if (newApp) {
    this.getTutorLocation({ appId: newApp })
    console.log('curr appId is :  ', newApp)
    setuserCurrentApp(newApp)
    // this.pickerLocationVisible = true
    // }
  }

  // handleSubmit(formName: string) {
  //   const form: any = this.$refs[formName]
  //   form.validate(async (valid: boolean) => {
  //     if (valid) {
  //       this.isDisableSubmit = true
  //       const action = 'addIssue'
  //       await (ADMINISISSUESAPI as any)
  //         // eslint-disable-next-line no-unexpected-multiline
  //         [action](
  //           this.formData.remark
  //             ? {
  //               location: Number(this.formData.location[2].split('_')[1]),
  //               describe: this.formData.describe,
  //               position: this.formData.position,
  //               remark: this.formData.remark
  //             }
  //             : {
  //               location: Number(this.formData.location[2].split('_')[1]),
  //               describe: this.formData.describe,
  //               position: this.formData.position
  //             },
  //           {
  //             app_id: this.userCurrentApp
  //           }
  //         )
  //         .then((res: any) => {
  //           if (res.stat === 1) {
  //             this.$message.success('提交成功')
  //             this.handleResetForm(formName)
  //             this.$router.push({ path: '/home' })
  //           }
  //           this.isDisableSubmit = false
  //         })
  //         .catch(() => {
  //           this.isDisableSubmit = false
  //         })
  //     } else {
  //       console.log('error submit!!')
  //       return false
  //     }
  //   })
  // }
  handleSubmit(formName: string) {
    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true

        // 根据 selectedApp.appId 设置相应的 API 实例
        console.log(this.selectedApp)
        let apiInstance
        switch (this.selectedApp) {
          case 1:
            apiInstance = ISSUESAPI
            break
          case 5:
            apiInstance = ADMINISISSUESAPI
            break
          case 6:
            apiInstance = FWBZISISSUESAPI
            break
          case 7:
            apiInstance = CGGLISISSUESAPI
            break
          case 8:
            apiInstance = SCGLISISSUESAPI
            break
          case 9:
            apiInstance = SPYYISISSUESAPI
            break
          case 10:
            apiInstance = GYGLISISSUESAPI
            break
          default:
            this.$message.error('无效的应用ID')
            this.isDisableSubmit = false
            return
        }
        let locationValue
        if (
          Array.isArray(this.formData.location) &&
          this.formData.location.length > 2 &&
          typeof this.formData.location[2] === 'string' &&
          this.formData.location[2].includes('_')
        ) {
          locationValue = Number(this.formData.location[2].split('_')[1])
          console.log('locationValue===>>>', locationValue)
        } else {
          console.warn('Invalid location data:', this.formData.location)
          // 设置默认值，例如 0，或根据实际业务逻辑调整
          locationValue = 0
        }
        // 构造提交的数据对象
        const requestData = this.formData.remark
          ? {
            location: locationValue,
            describe: this.formData.describe,
            position: this.formData.position,
            is_living: this.formData.is_living,
            remark: this.formData.remark
          }
          : {
            location: locationValue,
            describe: this.formData.describe,
            is_living: this.formData.is_living,
            position: this.formData.position
          }

        // 调用 API 并处理响应
        try {
          if (this.selectedApp === 1) {
            const res = await ISSUESAPI.addTutor(requestData, {
              app_id: this.selectedApp
            })
            if (res.stat === 1) {
              this.$message.success('提交成功')
              this.handleResetForm(formName)
              // this.$router.push({ path: '/home' })
              this.$router.push({ path: '/jumper' })
            }
          } else {
            const res = await apiInstance.addIssue(requestData, {
              app_id: this.selectedApp
            })
            if (res.stat === 1) {
              this.$message.success('提交成功')
              this.handleResetForm(formName)
              // this.$router.push({ path: '/home' })
              this.$router.push({ path: '/jumper' })
            }
          }
        } catch (error) {
          console.error('提交失败', error)
        } finally {
          this.isDisableSubmit = false
          this.$router.push({ path: '/jumper' })
        }
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleResetForm(formName: string) {
    this.liveIssueCn = ''
    this.defaultIssueIndex = [0, 0, 0]
    const form: any = this.$refs[formName]
    form.resetFields()
    this.formData.location = [0, 0, 0]
  }

  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.liveIssueCn = issueType.join('/')
    console.log('liveIssueCn====>>>', this.liveIssueCn)
    // this.liveIssueCn = this.selected.map((item) => item.name).join(' - ');
    this.formData.location = [
      res[0].value || res[0].id,
      res[1].value || res[1].id,
      res[2] ? res[2].value || res[2].id : ''
    ]
  }

  private handleChangeLocation(value: any) {
    console.log('下拉菜单改变')
  }

  handleSuccess(res: any) {
    if (res.stat === 1) {
      this.formData.remark = res.data.image_url
    }
  }

  handleExceed(files: any, fileList: any) {
    this.$message.warning(
      `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
      } 个文件`
    )
  }

  get getToken() {
    return getToken
  }

  get uploadImgUrl() {
    return baseURL + 'xz/uploadImage'
  }

  uploadImg() {
    const curr = getuserCurrentApp()
    if (curr === '') {
      this.$alert('请先选择支持部门', {
        type: 'warning',
        confirmButtonText: '知道了'
      })
    }
    console.log('开始上传图片======', curr)
  }

  beforeRemove(file: any) {
    return this.$confirm(`确定移除 ${file.name}？`)
  }

  private async getTutorLocation({ appId }: { appId: any }) {
    const { data } = await CONFIGAPI.getLocation({
      app_id: appId
    })
    let newData: any = []
    // 删掉掉没有基地的地区，移除转接虚拟基地
    data.map((item: any) => {
      if (item.children && item.children.length !== 0 && item.label.indexOf('转接') === -1) {
        newData.push(item)
      }
    })
    if (this.classObj.mobile) {
      // 手机端插件数据结构需要用value
      newData = JSON.parse(JSON.stringify(newData).replace(/"id"/g, '"value"'))
      console.log('手机端处理后的数据:', newData)
    }
    this.locationOptions = newData
    this.defaultIssueIndex = [0, 0, 0]
    console.log('defaultIssueIndex====>>>', this.defaultIssueIndex)
    console.log('locationOptions====>>>', this.locationOptions)
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get username() {
    return getDisplayName()
  }

  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  mounted() {
    // 根据 app_id 设置默认选中的工单
    // 获取 URL 中的 app_id
    const appId = getuserCurrentApp()
    console.log('this.$route.query.app_id===',appId)
    if (appId === '1') {
      this.selectedApp = 1 // IT/网络/直播保障
    } else if (appId === '5') {
      this.selectedApp = 5 // 行政工单
    } else {
      this.selectedApp = 1 // IT/网络/直播保障
    }
    this.handleAppChange(this.selectedApp)
    console.log('当前选择的应用ID：', this.selectedApp)
    this.defaultIssueIndex = [0, 0, 0]
    this.formData.location = [0, 0, 0]
    this.isMobile = this.isMobileFunc()
    this.getSysAppData()
    // this.getTutorLocation({ appId: 1 })
    // this.selectedApp = 1
    if (this.classObj.mobile) {
      // 如果是 mobile，初始化为含有 children 的结构

      const newVar = [{
        value: 1,
        label: '地区1',
        children: [
          { value: 1.1, label: '子地区1' },
          { value: 1.2, label: '子地区2' }
        ]
      }
      ]
      this.locationOptions = newVar
    }

  }

  private isMobileFunc() {
    const rect = document.body.getBoundingClientRect()
    const isMobile = rect.width - 1 < 992
    if (isMobile) {
      AppModule.ToggleDevice(DeviceType.Mobile)
      AppModule.CloseSideBar(true)
    }
    return isMobile
  }

  private getSysAppData() {
    this.pageLoading = this.$loading({
      lock: true,
      spinner: 'le',
      background: 'rgba(255, 255, 255, 0.2)'
    })
    const fetch_device = this.isMobile ? 'mobile' : 'pc'
    SYSAPI.getSysApp({ fetch_device: fetch_device }).then((res) => {
      if (res.stat && res.data.length > 0) {
        this.sysAppDataList = res.data
          .filter((item: { id: number; [key: string]: any }) => ![2, 3, 4].includes(item.id))
          .map((item: { id: number; name: string }) => {
            if (item.id === 1) {
              return { ...item, name: 'IT/网络/直播支持' }
            }
            return item
          })
      } else {
        this.$alert('获取应用列表失败，请联系管理员！', {
          type: 'warning',
          confirmButtonText: '知道了'
        })
      }
      this.pageLoading.close()
    })
  }

  private handleClick(item: any) {
    const appId = item.id
    const params = {
      app_id: appId
    }
    USERAPI.getUserRoles(params).then((res) => {
      if (res.stat) {
        const userRole = String(res.data.role)
        setRole(userRole)
        UserModule.setUserRole(userRole)
        setuserCurrentApp(appId)
        setuserCurrentAppName(item.name)
        const path = item.name === dashboardTicketKeywords ? '/dashboard' : '/'
        if (item.path) {
          this.$router
            .replace({
              path: item.path,
              query: { t: String(new Date().getTime()) }
            })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => {
            })
        } else {
          this.$router
            .replace({
              path: path,
              query: { t: String(new Date().getTime()) }
            })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => {
            })
        }
      } else {
        this.$alert('获取登录用户身份出错！', {
          type: 'warning',
          confirmButtonText: '知道了'
        })
      }
    })
  }

  private checkDashPerms() {
    const checkDashPerms = this.$route.query.check_dash_perms || 'true'
    return new Promise((resolve) => {
      if (checkDashPerms === 'true' && !this.isMobile) {
        SYSAPI.getDashPerms().then((res) => {
          if (res.stat && JSON.stringify(res.data) !== '{}') {
            const userRole = String(res.data.role)
            setRole(userRole)
            UserModule.setUserRole(userRole)
            setuserCurrentApp(res.data.app_id)
            setuserCurrentAppName(res.data.name)
            this.$router
              .replace({
                path: '/dashboard',
                query: { t: String(new Date().getTime()) }
              })
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              .catch(() => {
              })
          } else {
            resolve()
          }
        })
      }
      resolve()
    })
  }
}
